import {FiltersEnum} from 'filters-selections/enums';

export const classInstrumentFilterList = [
  FiltersEnum.InstrumentStatus,
  FiltersEnum.Audience,
  FiltersEnum.InstrumentType,
  FiltersEnum.Phase,
  FiltersEnum.Pillar,
];
